// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
    getAuth,
    GoogleAuthProvider,
    signInWithEmailAndPassword,
    signInWithPopup,
    
} from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBukSqT99Gjrc-ySxPkG8GgQjvCtZRY9lA",
    authDomain: "mixing-app-5667d.firebaseapp.com",
    projectId: "mixing-app-5667d",
    storageBucket: "mixing-app-5667d.firebasestorage.app",
    messagingSenderId: "279903626072",
    appId: "1:279903626072:web:7449970747cdde9f963b2d",
    measurementId: "G-NSR121CCTV"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app)
const provider = new GoogleAuthProvider();





const logIn = async (email, password) => {
    try {
        // Firebaseでログイン
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;

        // メールアドレスが確認済みかをチェック
        if (!user.emailVerified) {
            console.warn("Email not verified:", email);
            alert("Please verify your email address before logging in.");
            return;
        }

        console.log("User logged in:", user);

        // 検証済みユーザーの場合、サーバー通信など次の操作を続行
        // Flaskサーバーに送信する処理を追加
    } catch (error) {
        console.error("Error logging in:", error.message);
    }
};



// Google認証によるログイン
const googleSignIn = async () => {
    try {
        const userCredential = await signInWithPopup(auth, provider);
        const user = userCredential.user;
        console.log("User signed in with Google:", user);
        // Flaskサーバーに送信する処理をここに追加
    } catch (error) {
        console.error("Error signing in with Google:", error.message);
    }
};

export { auth, provider, logIn, googleSignIn };